var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-center", staticStyle: { "margin-top": "5px" } },
    [_c("b-spinner", { attrs: { label: "Spinning" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }